/**
 * Header Search Component
 *
 * Used to toggle class on search field
 */

import { Component } from 'js-component-framework';

/**
 * HeaderSearch Class
 */
export default class HeaderSearch extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.open = document.querySelector('.header-search-open');

    // Select all focus traps
    this.focusTraps = this.children.focusTraps;

    // Set up escape key listener function
    this.escapeListener = this.handleEscapeKey.bind(this);

    // Apply search toggle behavior
    this.initSearchToggle();

    // Apply focus trap behavior
    if (this.focusTraps.length) {
      this.initFocusTraps();
    }
  }

  handleEscapeKey(event) {
    if (event.key === 'Escape') {
      this.closeSearch();
    }
  }

  openSearch() {
    const { searchInput } = this.children;

    this.element.classList.add('is-open');
    document.addEventListener('keyup', this.escapeListener);
    searchInput.focus();
  }

  closeSearch() {
    this.element.classList.remove('is-open');
    document.removeEventListener('keyup', this.escapeListener);
    this.open.focus();
  }

  /**
   * Applies event listener to open and close button.
   */
  initSearchToggle() {
    const { close } = this.children;

    this.open.addEventListener('click', this.openSearch.bind(this));
    close.addEventListener('click', this.closeSearch.bind(this));
  }

  initFocusTraps() {
    this.focusTraps.forEach((trap) => {
      const focusDestination = trap.getAttribute('data-target');

      if (focusDestination) {
        trap.addEventListener('focus', () => { document.getElementById(focusDestination).focus(); });
      }
    });
  }
}
